import { Navigation } from '../../../scripts/modules/navigation/navigation';


/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    jQuery('body').on('click', '.action-card__shop-button', function (e) {
        let $etCommerce = null;

        // eslint-disable-next-line no-empty
        if (typeof etCommerce === 'undefined') {

        } else {
            $etCommerce = etCommerce;
        }

        const button = jQuery(this);
        const breadcrumb = jQuery('#dinamic-category-breadcrumb-content');
        const body = jQuery('body');
        const basketId = body.attr('data-sid');
        const catalog = breadcrumb.attr('data-product-specialty-identifier');
        const division = breadcrumb.attr('data-product-division-identifier');
        const dataIds = breadcrumb.attr('data-nav-id');
        const dataIdsList = dataIds !== '' ? dataIds.split('#') : '';
        const category = dataIdsList[dataIdsList.length - 1] || '';
        const productID = button.attr('id');
        const productIdentifier = button.attr('data-id');
        const productTitle = button.attr('data-name');
        const productType = button.attr('data-type') || '';
        const productTx = button.attr('data-tx') || '';
        const image = button.attr('data-img') || '';
        const tempVal = button.attr('data-value');
        const productCount = tempVal !== 'init' ? tempVal : jQuery(this).parent().parent().find('#action-card__amount')[0].value;

        let tempURLPrefix = `?productID=${productID}`;
        tempURLPrefix += category !== '' ? `&cat=${category}` : '';
        const productURL = `${window.location.origin + config.urls.productDetailPageHtml + tempURLPrefix}`;

        if (Number(productCount) > 0) {
            const etrackerCategory = [];
            let cartCategory = '%5B';

            if (etrackerCategoryForOrder.length) {
                etrackerCategoryForOrder.forEach((etrackerCategoryItem) => {
                    etrackerCategory.push(etrackerCategoryItem);
                    cartCategory += `'${etrackerCategoryItem}',`;
                });
                etrackerCategory.push(productType);
                cartCategory += `'${productType}'%5D`;
            } else {
                etrackerCategory.push(productType);
                cartCategory += `'${productType}'%5D`;
            }

            addProduct({
                productId: productID,
                articleNumber: productIdentifier,
                productName: productTitle,
                quantity: 1,
                imageSrc: image,
                href: productURL,
                category: etrackerCategory
            });

            const basketLink = `${config.urls.addToCart}?action=addproduct&product_id=${productID}&product_title=${encodeURIComponent(productTitle)}&product_amount=${productCount}&product_link=${encodeURIComponent(productURL)}&product_catalog=${catalog}&product_abstract=${productIdentifier}&product_division=${division}&product_tx=${productTx}&tracking_categories=${cartCategory}&category=${etrackerCategoryForOrder[etrackerCategoryForOrder.length - 1]}`;
            $.get(basketLink, (data) => {
                const etCommerceProduct = {
                    id: productID,
                    name: productIdentifier,
                    category: etrackerCategory,
                    price: '1.00',
                    currency: 'EUR',
                    variants: {},
                };

                if ($etCommerce) {
                    const etCommerceQuantity = Number(productCount);
                    if (productType !== 'Products') {
                        // no async (_etrackerOnReady.push) because this code runs
                        // in click event handler and the page is already complety loaded
                        // otherwise it will not track anything
                        etCommerce.sendEvent('viewProduct', etCommerceProduct);
                    }

                    // no async (_etrackerOnReady.push) because this code runs
                    // in click event handler and the page is already complety loaded
                    // otherwise it will not track anything
                    etCommerce.sendEvent('insertToBasket', etCommerceProduct, etCommerceQuantity, basketId);
                }

                const mediaquery = window.matchMedia('(max-width: 991px)');

                if (mediaquery.matches) {
                    $('#ks-cart-count').replaceWith(data);
                    $('#ks-mobile-button-cart').animate({ opacity: 0 }, 500);
                    $('#ks-mobile-button-cart').addClass('full');
                    $('#ks-mobile-button-cart').animate({ opacity: 1 }, 500);
                } else {
                    $('#ks-top-cart-dialog').animate({ opacity: 0 }, 500);
                    $('#ks-cart-count').replaceWith(data);
                    $('#ks-top-cart-dialog').animate({ opacity: 1 }, 500);
                    $('#ks-mobile-button-cart').addClass('full');
                }

                // extract new count from response
                // let content = '';
                // $(data).each((i,el) => {
                //     if(el.nodeName === 'SPAN') {
                //         content = el.innerHTML;
                //     }
                // });

                toastr.options.onclick = () => {
                    const $basketLink = $('.navigation__action.navigation__action--favorite > a');

                    if ($basketLink.length) {
                        // click the basket link so that the user
                        // navigates to the basket page when he
                        // clicked a toastr popup
                        $basketLink[0].click();
                    }

                    toastr.options.onclick = null;
                };

                toastr.info(`<div><b>${productTitle} (${productCount})</b> ${config.textResources.productCatalogConnectorConfig.add_to}.</div>`);
            });
        } else {
            const form = $('#product-quantity')[0];

            if (form) {
                form.reportValidity();
            }
        }

        return false;
    });
}

function addProduct(product) {
    const LOCAL_STORAGE_KEY = 'ks-checkout-products';
    const LOCAL_STORAGE_HREF_KEY = 'ks-checkout-back-href';
    const json = localStorage.getItem(LOCAL_STORAGE_KEY);
    const localStorageProductsMap = json ? JSON.parse(json) : {};

    if(localStorageProductsMap[product.productId]) {
        localStorageProductsMap[product.productId].quantity = localStorageProductsMap[product.productId].quantity + 1;
    } else {
        localStorageProductsMap[product.productId] = product;
    }
    
    localStorage.setItem(LOCAL_STORAGE_HREF_KEY, window.location.pathname + window.location.search); 
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(localStorageProductsMap)); 

    Navigation.updateCartNumber();
}